import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { ArchiveIcon, UnArchiveIcon } from '../../../vectors/index';
import { useEditTemplate } from '../hooks/useEditTemplate';
import { EnterpriseTemplate } from '../types';

type TemplateArchiveModalProps = {
    status: number;
    item: EnterpriseTemplate;
    handleClose: () => void;
};

const TemplateArchiveModal: FC<TemplateArchiveModalProps> = ({ handleClose, status, item }) => {
    const [errorText, setErrorText] = useState<string>('');

    const { editTemplate, isUpdatingTemplate } = useEditTemplate({ setErrorText });


    const handleUpdate = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message);
                handleClose();
            },
        };

        editTemplate({
            status: status,
            template_id: item.id,
        }, options);

    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                {status == 0 ? <UnArchiveIcon /> : <ArchiveIcon />}
                <br />
                <Typography variant="h4" >
                    Are you Sure to {status == 0 ? 'Active' : 'Archive'} this Templete
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
                <LoadingButton
                    loading={isUpdatingTemplate}
                    disabled={isUpdatingTemplate}
                    fullWidth
                    onClick={handleUpdate}
                    // startIcon={<Add />}
                    variant="contained"
                    color="primary"
                    type="submit"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                >
                    Yes
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default TemplateArchiveModal;
